import React, {Component} from 'react';
import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';
import {deleteNavigationLink, reorderNavigationLinks} from '../../../../../actions/navigationlinks';
import store, {history} from '../../../../../store';
import ConfirmPopup from '../../../../common/confirm-popup';
import NavigationLink from './navigation-link-item';

const NavigationLinkItem = SortableElement(({item, onDelete, onEdit}) => (
  <NavigationLink
    item={item}
    itemType="Category"
    onDelete={onDelete}
    onEdit={onEdit}
    status={item.attributes['category-status']}
  />
));

const NavigationLinksContainer = SortableContainer(({items, onDelete, onEdit}) => (
  <div>
    {items.map((value, index) => (
      <NavigationLinkItem
        index={index}
        item={value}
        key={`item-${value.id}`}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    ))}
  </div>
));

class NavigationLinksList extends Component {
  handleEdit = (id) => {
    history.push(`/admin/navigation/links/${id}/edit`);
  };

  handleDelete = (result) => {
    const {id} = this.state.delete;
    this.setState({delete: {show: false}});
    if (result) {
      store.dispatch(deleteNavigationLink(id));
    }
  };

  handleSort = ({oldIndex, newIndex}) => {
    if (oldIndex !== newIndex) {
      const newOrdering = arrayMove(this.props.navigationLinks, oldIndex, newIndex);
      store.dispatch(reorderNavigationLinks(newOrdering));
    }
  };

  toggleDeletePopup = (id) => {
    this.setState({
      delete: {
        show: !this.state.delete.show,
        id
      }
    });
  };

  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    };
  }

  render() {
    return (
      <div>
        <NavigationLinksContainer
          helperClass="product-reordering"
          items={this.props.navigationLinks}
          lockAxis="y"
          onDelete={this.toggleDeletePopup}
          onEdit={this.handleEdit}
          onSortEnd={this.handleSort}
          pressDelay={150}
        />

        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE NAVIGATION LINK?"
              onClose={this.handleDelete}
            >
              <p>
                Are you sure you want to delete the selected navigation link?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default NavigationLinksList;



// WEBPACK FOOTER //
// ./src/components/admin/navigation/links/list/navigationlinks-list.jsx